import React from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import VerbButton, { VERB_BUTTON_TYPE } from '../VerbButton';
import LoadingIndicator from '../LoadingIndicator';

const LoadMorePagination = (props) => {
    const { currentlyShownNum, totalNum, name, loadMoreClick, loading = false, showLoadMoreBtn = true } = props;
    return (
        <div className={'load-more-pagination-container'}>
            {loading ? (
                <LoadingIndicator className={'load-more-loading'} />
            ) : (
                <>
                    {showLoadMoreBtn && (
                    <>
                        <p>
                            Showing {currentlyShownNum} of {totalNum}
                        </p>
                        <ProgressBar
                            key={`${name}-progressbar`}
                            now={(currentlyShownNum / totalNum) * 100}
                            className={'load-more-pagination-progress-bar'}
                        />
                        <div onClick={loadMoreClick} className={'load-more-container'}>
                            <VerbButton
                                buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                                textId={'SHOW_MORE'}
                                defaultMessage={'SHOW MORE'}
                            />
                        </div>
                    </>
                    )}
                </>
            )}
        </div>
    );
};

LoadMorePagination.propTypes = {
    currentlyShownNum: PropTypes.number,
    totalNum: PropTypes.number,
    name: PropTypes.string,
    loadMoreClick: PropTypes.func,
    loading: PropTypes.bool,
    showLoadMoreBtn: PropTypes.bool
};

export default injectIntl(LoadMorePagination);
